// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth
((Drupal, once) => {
  function scrollTrigger(item, options = {}) {
    const threshold = item.dataset.threshold ? item.dataset.threshold : 0.5;
    // eslint-disable-next-line no-new,no-use-before-define
    addObserver(item, { ...options, threshold });
  }

  function addObserver(el, options) {
    if (!("IntersectionObserver" in window)) {
      if (options.cb) {
        options.cb(el);
      } else {
        // eslint-disable-next-line no-new,no-undef
        entry.target.classList.add("active");
      }
      return;
    }
    // eslint-disable-next-line no-new,no-shadow,no-undef,no-unused-vars
    const observer = new IntersectionObserver((entries, observer) => {
      // this takes a callback function which receives two arguments: the elemts list and the observer instance
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("active");
          observer.unobserve(entry.target);
        }
      });
    }, options);
    observer.observe(el);
  }

  Drupal.behaviors.animate = {
    attach(context) {
      const items = once("animated", ".js-scroll-reveal", context);

      items.forEach((item) => {
        const children = item.querySelectorAll("[data-scrollreveal]");
        const { rootMargin } = item.dataset;

        if (children.length) {
          children.forEach((elm) => {
            elm.classList.add("scroll-reveal");
            if (rootMargin) {
              elm.dataset.rootMargin = rootMargin;
            }
            scrollTrigger(elm);
          });
        } else {
          item.classList.add("scroll-reveal");
          scrollTrigger(item);
        }
      });
    },
  };
})(Drupal, once);
